import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby';
import { connect } from 'react-redux';
import posed from 'react-pose';
import classNames from 'classnames';

import Nav from '../components/nav';

import '../sass/main.scss';

const MainPose = posed.div({
  margin: { marginLeft: 280 },
  noMargin: { marginLeft: 0 }
});

const Layout = ({ children, openMenu }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <React.Fragment>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'Tes styleguide' },
            { name: 'keywords', content: 'tes, styleguide' },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <div className={`l-wrapper container-fluid ${openMenu ? 'l-wrapper--open-menu' : ''}`}>
          <div className="row">
            <Nav />
            <MainPose initialPose="margin" pose={openMenu ? 'margin' : 'noMargin'} className={classNames('l-main', { 'l-main--open-menu': openMenu })}>
              {children}
              <footer className="l-footer">
                <p>
                  Copyright @ <a href="https://www.tes.com">Tes</a> {(new Date()).getFullYear()}
                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                  v. 1.0.0 - <a href="https://github.com/tes/app-styleguide">Repository</a>
                </p>
              </footer>
            </MainPose>
          </div>
        </div>
      </React.Fragment>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  openMenu: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => ({ openMenu: state.openMenu });

export default connect(mapStateToProps)(Layout);
